{
  "Clear search": "Limpar busca"
}
